export default __webpack_public_path__ + "static/media/edit-photo-icon.4530ce9b.svg";